import { LibraryDatasetTable } from '@/components'
import { config } from '@/config'
import { DatasetSimple } from '@/interfaces'

import { useFinanceDatasets } from '../hooks'

interface Props {
  datasets: DatasetSimple[]
}

export const FinancesDatasetsTable = ({ datasets }: Props) => {
  const { cloneDataset, isCloneDatasetInProgress, removeDataset } =
    useFinanceDatasets()

  const allDatasetNames = datasets.map(x => x.name || '')

  const handleCloneDataset = (
    datasetId: number,
    datasetName: string,
    onSuccess: () => void
  ) => {
    cloneDataset({ datasetId, name: datasetName }, { onSuccess })
  }

  return (
    <LibraryDatasetTable
      datasets={datasets}
      getDetailsLink={datasetId =>
        `${config.links.library.finances}/${datasetId}`
      }
      isCloneInProgress={isCloneDatasetInProgress}
      onRemoveClicked={datasetId => removeDataset(datasetId)}
      onCloneClicked={handleCloneDataset}
      allDatasetNames={allDatasetNames}
    />
  )
}
